module.exports = __webpack_public_path__ + "static/media/airplanemode_active-black-18dp.d56cb8af.svg";